var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "select-box-container"
  }, [_c('select-box-left-panel', {
    attrs: {
      "data": _vm.data
    },
    on: {
      "click-tab": _vm.changeTab,
      "click-item": _vm.changeItem
    }
  }), _vm._v(" "), _c('select-box-index', {
    attrs: {
      "alpha": _vm.indexArr
    },
    on: {
      "index-click": _vm.changeJumpCount
    }
  }), _vm._v(" "), _c('select-box-right-panel', {
    attrs: {
      "total-select": _vm.totalSelect,
      "current-select": _vm.currentSelect,
      "data": _vm.data.secondTabs[_vm.data.activeTab].items[_vm.data.secondTabs[_vm.data.activeTab].activeIndex],
      "scroll-distance": _vm.scrollDistance
    },
    on: {
      "select-change": _vm.handleSelectChange
    }
  })], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f71c65ee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SelectBox.vue
// module id = c98b
// module chunks = 1